export default __webpack_public_path__ + "static/dolomite-devices-header-image-f06f71983ee40f210fdfc5988db0c747.png";